import { Measurements } from '~/utility/BinSentry-ui-utility';
import moment from 'moment';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { BinIssueStateMixin } from './bin-issue-state-mixin';

class BinIssueStateLevelSelect extends BinIssueStateMixin(LitEntity) {
  constructor() {
    super();
    this.collectedFields = ['correctedLevelDate', 'selectedLevelWeight', 'selectedLevelHeight', 'disputedLevelId'];
  }

  static get styles() {
    return [...super.styles, css`
      :host {
        align-items: center;
      }
      bin-calendar {
        width: 100%;
        flex-grow: 5;
        height: 25vh;
        max-height: 160px;
      }
      bin-profile {
        height: 25vh;
        max-height: 160px;
        flex-shrink: 4;
        width: auto;
      }
      .selected-level {
        pointer-events: none;
        min-width: 33%;
        padding: 1.5em;
        margin-top: 1em;
        background-color: var(--blue-40);
        border: 2px solid var(--blue-50);

        opacity: 0;
        max-height: 0;
        transition: max-height .2s, opacity .2s;
      }
      .selected-level.in {
        pointer-events: all;
        opacity: 1;
        max-height: 160px;
      }
      .selected-level h3 {
        margin: 0 0 1em 0;
      }
      .selected-level .flex {
        justify-content: space-between;
      }
    `];
  }

  render() {
    const measurement = Measurements.get('weight');
    const measurementHtml = measurement.html({ weight: this.data.selectedLevelWeight });

    return html`
      <div class="flex col">
        <h2>Select the Level that You Disagree With</h2>
        <div class="flex row">
          <bin-calendar .href="${this.href}" @select="${this._selectBinLevel}" hide-forecast></bin-calendar>
          <bin-profile
            .href="${this.href}"
            .level="${{ feedHeight: this.data.selectedLevelHeight || 0 }}"
            ignore-latest-level
          ></bin-profile>
        </div>

        <div class="selected-level ${this._hasSelectedLevel() ? 'in' : ''}">
          <h3>Selected Level</h3>
          <div class="flex row">
            <bn-property label="Date" stacked>${moment(this.data.correctedLevelDate).format('MMMM D, h:mm a')}</bn-property>
            <bn-property label="Weight" stacked>${measurementHtml}</bn-property>
          </div>
        </div>
      </div>
      ${this.renderNext()}
    `;
  }

  updated() {
    this.stateHasData = this._hasSelectedLevel();
  }

  _hasSelectedLevel() {
    return !!this.data.correctedLevelDate;
  }

  _selectBinLevel(e) {
    const { point } = e.detail;
    this.stateHasData = !point.forecast;
    if (point.forecast) {
      this.data = {};
      this.requestUpdate();
      return;
    }

    this.data.disputedLevelId = point.id;
    this.data.correctedLevelDate = point.date.toISOString();
    this.data.selectedLevelHeight = point.feedHeight;
    this.data.selectedLevelWeight = point.volume * this.entity.properties.bulkDensity;
    this.requestUpdate();
  }
}

window.customElements.define('bin-issue-state-level-select', BinIssueStateLevelSelect);
